module.exports = __webpack_public_path__ + "db11f2346e8923c9c6ddaa0b73a8db56.jpg";